<template>
  <div class="w-screen md:max-w-screen-xl m-auto px-4">
    <Banner
      :hide-button="!content?.callToAction?.label"
      :text="content?.mainMediaBlock?.title"
      :call-to-action-link="content?.callToAction?.url"
      :description="content?.mainMediaBlock?.subtitle"
      :action-label="content?.callToAction?.label"
      :featured-media="featuredMedia"
      :action="() => handleCTA(content?.callToAction?.url)"
    />
  </div>
</template>
<script setup lang="ts">
const { content = {} } = defineProps<{ content: any }>()
const { toggleDateRequestSidebar } = useUiState()
const route = useRoute()
const emit = defineEmits(['openContactForm', 'openCaseStudyForm'])

const featuredMedia = computed(() => [
  {
    src: content?.mainMediaBlock?.media?.url,
    alt: strapiImageGetters.getAlternativeText(
      content?.mainMediaBlock?.media?.data
    ),
  },
])
const handleCTA = (action: string) => {
  if (action === 'openEventRequestForm') {
    toggleDateRequestSidebar(route.name?.toString(), 'strapi_component')
  } else if (action === 'openPartnerContactForm') {
    emit('openContactForm')
  } else if (action === 'openCaseStudyForm') {
    emit('openCaseStudyForm')
  }
}
</script>

<style scoped lang="postcss"></style>
